import { PlacementAxis } from "@react-aria/overlays";
import React, { FC, SVGAttributes } from "react";
import styled, { css } from "styled-components";
import { tombac } from "../../shared";
import { PopoverVariant } from "./Popover";

export type PopoverArrowProps = SVGAttributes<SVGSVGElement> & {
  placement: PlacementAxis;
  variant: PopoverVariant;
};

export const PopoverArrow: FC<PopoverArrowProps> = (props) => (
  <ArrowSvg {...props} viewBox="0 0 14 14">
    <filter id="shadow">
      <feDropShadow
        dx="0"
        dy="0"
        stdDeviation="16"
        floodColor="rgba(0, 0, 0, 0.16)"
      />
    </filter>
    <path d="M0 0 H14 L7 7 Z" filter="url(#shadow)" />
  </ArrowSvg>
);

const arrowPlacements = tombac.variant<PopoverArrowProps>("placement", {
  bottom: css`
    bottom: 100%;
    transform: translate(-50%) rotate(180deg);
  `,
  left: css`
    left: 100%;
    transform: translateY(-50%) rotate(-90deg);
  `,
  right: css`
    right: 100%;
    transform: translateY(-50%) rotate(90deg);
  `,
  top: css`
    transform: translate(-50%);
    top: 100%;
  `,
});

const arrowVariants = tombac.variant<PopoverArrowProps>("variant", {
  default: css`
    fill: ${tombac.color.white};
  `,
  danger: css`
    fill: ${tombac.color("danger", 400)};
  `,
  inverted: css`
    fill: ${tombac.color.black};
  `,
});

const ArrowSvg = styled.svg<PopoverArrowProps>`
  all: initial;
  height: ${tombac.unit(14)};
  position: absolute;
  width: ${tombac.unit(14)};
  z-index: -1;

  ${arrowPlacements}
  ${arrowVariants}
`;
